// extracted by mini-css-extract-plugin
export default {"simpleListWrapper":"simpleListWrapper__kRrij","presetList":"presetList__1pwBw","presetListItem":"presetListItem__2GNoz"};